import {ServiceTeamMember} from "./models/ServiceTeam";
import {
    LegalAgreementsWithoutProfiles,
    PartnerResource,
    PartnerResourceRequest,
    SearchPartnerResults
} from "./models/PartnerResource";
import {ClientRelationshipGroupInformation} from "./models/ClientRelationshipGroupHierarchy";
import {get, HttpOptions} from "../core/api";

export const getServiceTeam = (resourceCode: string): Promise<ServiceTeamMember[]> => {
    return get(`/partner/partners?resourceCode=${resourceCode}`)
        .then((res: Response) => res.json());
}

export const getPartnerDetail = (partnerCode: string): Promise<ServiceTeamMember> => {
    return get(`/partner/partnerDetail?partnerCode=${partnerCode}`)
        .then((res: Response) => res.json());
}

export const getPartnerResources = (partnerResourceRequest: PartnerResourceRequest): Promise<PartnerResource[]> => {
    const params: HttpOptions = {
        queryParams: partnerResourceRequest
    }

    return get(`/partner/linkedResources`, params).then((res: Response) => {
        if (res.status === 200 || res.status === 201) {
            return res.json()
        } else {
            return [];
        }
    });
}

export const getLegalAgreementsWithoutProfile = (): Promise<LegalAgreementsWithoutProfiles[]> => {
    return get("/asset/legalAgreementWithoutProfile")
        .then((res: Response) => res.json());
}

export const searchPartners = (partnerCode: string, page?: number): Promise<SearchPartnerResults> => {
    const params: HttpOptions = {
        queryParams: {
            partnerCode,
            page: page && page > 1 ? page.toString() : "1",
        }
    }

    return get(`/partner/searchPartners`, params)
        .then((res: Response) => res.json());
}

export const getClientRelationshipGroups = (resourceCode: string): Promise<ClientRelationshipGroupInformation> => {
    return get(`/client-management/profiles/clientRelationshipGroupInfo/${resourceCode}`)
        .then((res: Response) => res.json());
}

export const partnerApiClient = {
    getServiceTeam: getServiceTeam,
    getPartnerDetail: getPartnerDetail,
    getPartnerResources: getPartnerResources,
    getLegalAgreementsWithoutProfile: getLegalAgreementsWithoutProfile,
    searchPartners: searchPartners,
    getClientRelationshipGroups: getClientRelationshipGroups,
};
